import CalculateIcon from '@mui/icons-material/Calculate';
import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getDeepViewLineageEntry } from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const ValueCollected = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const stage2Text = getDeepViewLineageEntry(
    deepViewData,
    columnKey,
  )?.stage2_prefilled;

  if (!stage2Text) return null;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #0288D180",
          borderRadius: "8px",
          backgroundColor: "#0288D10A",
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <CalculateIcon
            sx={{
              color: "#01579B",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#01579B",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            How the value was calculated
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#01579B",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(stage2Text)}
        </Typography>
      </Box>
    </>
  );
};

export default ValueCollected;
